import { render, staticRenderFns } from "./Nacionalidade.vue?vue&type=template&id=32a5a93b&scoped=true&"
import script from "./Nacionalidade.vue?vue&type=script&lang=js&"
export * from "./Nacionalidade.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a5a93b",
  null
  
)

export default component.exports